module.exports = __webpack_public_path__ + "static/media/Statement.b3b3d02a.svg";